import UserAdminMyPage from 'components/user-admin/UserAdminMyPage';

export default function St11UserAdminMyPage() {
  return <UserAdminMyPage solType={'ST11'} />;
}
